import React, { useState, useEffect } from 'react';
import { useAppContext } from '../../context/AppContext';
import { updateData as updateUserData } from '../../services/updateData';
export const ProfileSettings = () => {
    const { token, base_url, user, setUser } = useAppContext();
    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        job_title: '',
        password: '',
        confirm_password: '',
    });
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (user) {
            setFormData({
                first_name: user.first_name || '',
                last_name: user.last_name || '',
                job_title: user.job_title || '',
                password: '',
                confirm_password: '',
            });
        }
    }, [user]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        if (formData.password && formData.password !== formData.confirm_password) {
            window.showAlert(400, 'Passwords do not match');
            setIsLoading(false);
            return;
        }

        try {
            const updatePayload = {
                first_name: formData.first_name,
                last_name: formData.last_name,
                job_title: formData.job_title,
            };

            if (formData.password) {
                updatePayload.password = formData.password;
                updatePayload.confirm_password = formData.confirm_password;
            }

            const response = await updateUserData(
                token,
                `${base_url}/apis/admin/profile`,
                updatePayload
            );

            if (response && response.user) {
                setUser(response.user);
                window.showAlert(200, 'Profile updated successfully!');
                setFormData((prev) => ({
                    ...prev,
                    password: '',
                    confirm_password: '',
                }));
            } else {
                window.showAlert(
                    response?.status || 500,
                    response?.msg || 'Failed to update profile. Please try again.'
                );
            }
        } catch (err) {
            window.showAlert(err.status, err?.msg || 'Failed to update profile. Please try again.');
            console.error('Update profile error:', err);
        } finally {
            setIsLoading(false);
        }
    };

    if (!user) {
        return <div>Loading...</div>;
    }

    return (
        <div className="admin-profile">
            <h2 className="admin-profile__title">My Profile</h2>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="first_name" className="form-label">
                        First Name
                    </label>
                    <input
                        type="text"
                        id="first_name"
                        name="first_name"
                        className="form-input"
                        value={formData.first_name}
                        onChange={handleInputChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="last_name" className="form-label">
                        Last Name
                    </label>
                    <input
                        type="text"
                        id="last_name"
                        name="last_name"
                        className="form-input"
                        value={formData.last_name}
                        onChange={handleInputChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="job_title" className="form-label">
                        Job Title
                    </label>
                    <input
                        type="text"
                        id="job_title"
                        name="job_title"
                        className="form-input"
                        value={formData.job_title}
                        onChange={handleInputChange}
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="password" className="form-label">
                        New Password (leave blank to keep current password)
                    </label>
                    <input
                        type="password"
                        id="password"
                        name="password"
                        className="form-input"
                        value={formData.password}
                        onChange={handleInputChange}
                        autoComplete="new-password"
                    />
                </div>

                {formData.password && (
                    <div className="form-group">
                        <label htmlFor="confirm_password" className="form-label">
                            Confirm New Password
                        </label>
                        <input
                            type="password"
                            id="confirm_password"
                            name="confirm_password"
                            className="form-input"
                            value={formData.confirm_password}
                            onChange={handleInputChange}
                            autoComplete="new-password"
                        />
                    </div>
                )}

                <div className="form-actions admin-profile__actions">
                    <button type="submit" className="btn btn-primary" disabled={isLoading}>
                        {isLoading ? 'Updating...' : 'Update Profile'}
                    </button>
                </div>
            </form>
        </div>
    );
};
